import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../framework/dialog";
import { CalendarTaskState, DialogButtonType } from "ui/Scripts/source/models/enums";
import { Base } from "ui/Scripts/source/framework/base";
import { ICalendarTaskCategoryListItem } from "ui/Scripts/source/models/calendarTaskCategory/calendarTaskCategoryListItem";
import { CalendarTaskCategoryListLine, SelectCalendarTaskCategory } from "./selectCalendarTaskCategory";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IdCode, IIdCode } from "source/models/common/idCode";
import { IdCodeListLine, SelectIdCodeDialog } from "../framework/selectIdCodeDialog";
import { EndlessList, IEndlessList } from "ui/Scripts/source/models/common/endlessList";

export const CalendarTaskCategoryNotSetId = "00000000-0000-0000-0000-000000000001";

export interface ICalendarTaskViewSearchDialogProp {
    categories: ICalendarTaskCategoryListItem[];
    categoryId: string;
    stateId: string;
    filter: string;
    onOk: (filter: string, stateId: string, categoryId: string) => void;
    onCancel: () => void;
}

export interface ICalendarTaskViewSearchDialogState {
    categories: IIdColorTitle[];
    states: IIdCode[];
    categoryId: string;
    stateId: string;
    filter: string;
    showSelectCategoryDialog: boolean;
    showSelectStateDialog: boolean;
}

export class CalendarTaskViewSearchDialog extends React.Component<ICalendarTaskViewSearchDialogProp, ICalendarTaskViewSearchDialogState> {
    private getStates(): IIdCode[] {
        const result: IIdCode[] = [];
        result.push(IdCode.createIdCode("-1", "'" + Translations.All + "'"));
        return result.concat([
            IdCode.createIdCode(CalendarTaskState.NotStarted.toString(10), Translations.CalendarTaskStateNotStarted),
            IdCode.createIdCode(CalendarTaskState.Started.toString(10), Translations.CalendarTaskStateStarted),
            IdCode.createIdCode(CalendarTaskState.Finished.toString(10), Translations.CalendarTaskStateFinished),
        ]);
    }

    private gettateById(stateId: string): IIdCode {
        const state = this.state;
        return state.states.find(i => i.id === stateId) ?? state.states[0];
    }

    private getCategories(props: ICalendarTaskViewSearchDialogProp): IIdColorTitle[] {
        const result: IIdColorTitle[] = [];
        result.push(IdColorTitle.createIdColorTitle(Base.emptyGuid, "#fff", "'" + Translations.All + "'"));
        result.push(IdColorTitle.createIdColorTitle(CalendarTaskCategoryNotSetId, "#fff", "'" + Translations.NotSet + "'"));
        return result.concat(props.categories.map((item) => IdColorTitle.createIdColorTitle(item.id, item.color, item.code)));
    }

    private getCategoryById(categoryId: string): IIdColorTitle {
        const state = this.state;
        return state.categories.find(i => i.id === categoryId) ?? state.categories[0];
    }

    constructor(props: ICalendarTaskViewSearchDialogProp) {
        super(props);
        this.state = {
            categories: this.getCategories(props),
            states: this.getStates(),
            categoryId: props.categoryId,
            stateId: props.stateId,
            filter: props.filter,
            showSelectCategoryDialog: false,
            showSelectStateDialog: false
        };
    }

    handleChangeCategoryDialogOk = (id: string) => {
        this.setState({
            showSelectCategoryDialog: false,
            categoryId: id,
        });
    };

    handleChangeCategoryDialogCancel = () => {
        this.setState({
            showSelectCategoryDialog: false
        });
    };

    handleLoadStateTypes = (page: number): Promise<IEndlessList<IIdCode>> => {
        return new Promise<IEndlessList<IIdCode>>((resolve, reject) => {
            const result = new EndlessList<IIdCode>(null, IdCode);
            result.items = this.state.states;
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    handleChangeStateDialogOk = (stateId: string, _code: string) => {
        this.setState({
            showSelectStateDialog: false,
            stateId
        });
    };

    handleChangeStateDialogCancel = () => {
        this.setState({
            showSelectStateDialog: false
        });
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "filter") {
            this.setState({ filter: value });
        }
    };

    handleOkClick = () => {
        const state = this.state;
        // this.props.onOk(!Base.isNullOrEmpty(this.state.stateId) && this.state.stateId !== Base.emptyGuid ? this.state.stateId : null,
        //     !Base.isNullOrEmpty(this.state.unitId) && this.state.unitId !== Base.emptyGuid ? this.state.unitId : null);
        this.props.onOk(state.filter, state.stateId, state.categoryId);
    };

    handleCancelClick = () => {
        this.props.onCancel();
    };

    handleClearClick = () => {
        this.setState({ filter: "", stateId: "-1", categoryId: Base.emptyGuid });
    };

    render() {
        const state = this.state;
        // const taskStates = state.taskStates;
        // const taskState = this.getTaskStateById(taskStates, state.stateId);
        const category = this.getCategoryById(state.categoryId);
        const calendarTaskState = this.gettateById(state.stateId);
        const dialogClasses = "calendarTaskViewSearchDialog";
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.SearchCalendarTasks}
                body={
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group roWhite">
                                    <label className="control-label">{Base.upperCaseFirst(Translations.SearchCondition)}</label>
                                    <input className="form-control" type="text" name="filter" title={Translations.SearchCondition} maxLength={50} value={state.filter} required={true} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group roWhite">
                                    <label className="control-label">{Translations.State}</label>
                                    <div className="form-control unitLine">
                                        <IdCodeListLine
                                            item={calendarTaskState}
                                            selected={false}
                                            onClick={(_id: string) => { this.setState({ showSelectStateDialog: true }); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group roWhite">
                                    <label className="control-label">{Translations.CalendarTaskCategory}</label>
                                    <CalendarTaskCategoryListLine
                                        classes={"form-control unitLine"}
                                        item={category}
                                        selected={false}
                                        onClick={(_id: string) => { this.setState({ showSelectCategoryDialog: true }); }}
                                    />
                                </div>
                            </div>
                        </div>
                        {state.showSelectStateDialog &&
                            <SelectIdCodeDialog
                                title={Translations.SelectState}
                                selectedId={state.stateId}
                                loadIdCodes={this.handleLoadStateTypes}
                                onOk={this.handleChangeStateDialogOk}
                                onCancel={this.handleChangeStateDialogCancel}
                            />
                        }
                        {state.showSelectCategoryDialog &&
                            <SelectCalendarTaskCategory
                                categories={state.categories}
                                categoryId={state.categoryId}
                                onOk={this.handleChangeCategoryDialogOk}
                                onCancel={this.handleChangeCategoryDialogCancel}
                            />
                        }
                    </div>
                }
                buttons={[
                    { title: Translations.Clear, buttonType: DialogButtonType.Default, classes: "mr-auto", onClick: this.handleClearClick },
                    { title: Translations.OK, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick },
                    { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }
                ]}
                onClose={this.handleCancelClick}/>
        );
    }
}